module.exports = __webpack_public_path__ + "img/quote-3-white.58a4aaa7.webp";